<template>
  <ak-button
    :type="type"
    :to="to"
    class="ak-navbar__btn"
    :color="color"
    :disabled="disabled"
    v-bind="attrs"
    @click="clicked"
  >
    <slot />
  </ak-button>
</template>

<script>
import { defineComponent } from 'vue'
import Button from '../button/Button.vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-navbar-button>Click Me</ak-navbar-button>
   */
  name: 'AkNavbarButton',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [Button.name]: Button,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    color: {
      type: String,
      default: 'transparent',
    },
  },

  /**
   * @type {Array}
   * @description The list of events that this component can trigger
   */
  emits: ['click'],

  /**
   * @param {Object} props - The properties of the component
   * @param {Object} options - The setup options
   * @param {Function} options.emit - The emit method for triggering events
   * @param {Object} options.attrs - The attributes method for the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props, { emit, attrs }) {
    const clicked = (e) => {
      /* istanbul ignore if */
      if (e && e.originalEvent instanceof Event) {
        e.preventDefault()
        e.stopPropagation()
      }
      emit('click', e)
    }

    return {
      clicked,
      attrs,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-navbar__btn {
  min-height: 3.5rem;
  border-radius: 0;
}
</style>
